
import React from "react";
import {State, ToggleName, Action} from "./State"
import {Fetcher} from "./models/Fetcher";
import {User} from "./models/User";

export class SignInFetchers {
    currentUser: Fetcher
    sessionDestroy: Fetcher
    sessionNew: Fetcher
    sessionCreate: Fetcher

    constructor() {
        this.currentUser = new Fetcher('/users/me.json');
        this.sessionDestroy = new Fetcher('/sessions/destroy.json');
        this.sessionNew = new Fetcher('/sessions/new.json');
        this.sessionCreate = new Fetcher('/sessions/create.json');
    }

    setOnChange(changer:() => void) {
        this.currentUser.onChange = changer;
        this.sessionDestroy.onChange = changer;
        this.sessionNew.onChange = changer;
        this.sessionCreate.onChange = changer;
    }
}

class SignIn {
    state : State;
    dispatch : React.Dispatch<Action>;

    constructor(state : State, dispatch : React.Dispatch<Action>) {
        // super(state, dispatch);
        // console.log("SignIn");
        this.state = state;
        this.dispatch = dispatch

        // this.checkSignIn();
        console.log("SignIn constructed")
        this.state.signInFetchers.setOnChange(() => {  dispatch({type: 'change'}) });
    }

    fetchers() {
        return this.state.signInFetchers;
    }

    isSignedIn(): boolean {
        return !!this.state.user;
    }

    currentUser(): User | null {
        return this.state.user;
    }

    checkSignIn() {
        if (this.state.user || this.state.toggles.has('checked-sign-in')) {
            return;
        }
        this.state.signInFetchers.currentUser.get(null, (json) => {
            console.log("me response user", json);
            if(json.user) {
                let user = Object.assign(new User(), json.user);
                if (this.state.user !== user) {
                    this.dispatch({type: 'set-user', payload: user})
                }
            }
            this.dispatch({type: 'toggle-set', payload: 'checked-sign-in', value: true})
        })
    }

    signOut() {
        console.log("SignIn signOut state", this.state);
        this.state.signInFetchers.sessionDestroy.get(null, (json) => {
            this.dispatch({type: 'sign-out'})
        });
    }

    sessionNew(email: string) {
        console.log("sessionNew", email)
        this.state.signInFetchers.sessionNew.get({email: email}, (json) => {
            this.dispatch({type: 'set-email-verifying', payload: json.email});
            this.dispatch({type: 'toggle-set', payload: 'sent-verify-email', value: true})
        });
    }

    verifyCode(email: string | null = null, code: string | null = null) {
        email = email || this.state.emailVerifying;
        code = code || this.state.codeVerifying;
        this.state.signInFetchers.sessionCreate.post({email: email, otp: code}, (json) => {
            let user = Object.assign(new User(), json.user);
            this.dispatch({type: 'set-user', payload: user})
        })
    }

    pleaseVerify() {
        return <>
            <div className="row my-2">
                <div className="input-group mb-3 col-md-6 col-md-offset-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="inputGroup-email">Email</span>
                    </div>
                    <input type="text" className="form-control" aria-label="Default"
                           autoComplete="email"
                           aria-describedby="inputGroup-email"
                           onChange={(e) => {
                               this.dispatch({type: 'set-email-verifying', payload: e.target.value})
                           }}
                    />
                </div>
            </div>
            { this.state.signInFetchers.sessionNew.renderErrors() }
            <div className="row my-3">
                <div className="md-12 text-center">
                    <button className={"btn btn-primary btn-lg"}
                            disabled={this.state.signInFetchers.sessionNew.isInProgress()}
                            onClick={() => this.sessionNew(this.state.emailVerifying)}>
                        Verify Email
                    </button>
                </div>
            </div>
        </>
    }

    enterCode() {
        return <>
            { this.state.signInFetchers.sessionDestroy.renderErrors() }
            <div className="row my-3">
                <div className="md-12 text-center">
                    {"Please check the email for "}
                    <b>{this.state.emailVerifying}</b>
                    {" • "}
                    <a href="#" onClick={() => {this.signOut()}}>Change Email</a>
                </div>
            </div>
            <div className="row my-3">
                <div className="input-group mb-3 col-md-6 col-md-offset-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text" id="inputGroup-code">Code</span>
                    </div>
                    <input type="text" className="form-control" aria-label="Default" name="otp"
                           autoComplete="one-time-code"
                           value={this.state.codeVerifying}
                           aria-describedby="inputGroup-code"
                           onChange={(e) => {
                               this.dispatch({type: 'set-code-verifying', payload: e.target.value})
                           }}
                           onKeyUp={event => event.key === 'Enter' && this.verifyCode()}
                    />
                </div>
            </div>
            { this.state.signInFetchers.sessionCreate.renderErrors() }
            <div className="row my-3">
                <div className="md-12 text-center">
                    <button className={"btn btn-primary btn-lg"}
                            disabled={this.state.signInFetchers.sessionCreate.isInProgress()}
                            onClick={() => this.verifyCode()}
                    >
                        Verify
                    </button>
                </div>
            </div>
        </>;
    }

    signedIn() {
        return <>
            { this.state.signInFetchers.sessionDestroy.renderErrors() }
            <div className="row my-3">
                <div className="md-12 text-center">
                    Verified as <b>{this.state.user?.email}</b>
                    {" • "}
                    <a href="#" onClick={() => {this.signOut()}}>Change Email</a>
                </div>
            </div>
        </>;
    }

    handle() {
        return <>
            {this.state.user ? this.signedIn() : (this.state.toggles.has('sent-verify-email') ? this.enterCode() : this.pleaseVerify())}
        </>
    }
}

export default SignIn
